import React from 'react';
import { Redirect } from 'react-router-dom';
import Error404 from 'src/views/Error404';
import Login from 'src/views/Login';
import Profil from 'src/views/Profile';
import UnauthorizedView from 'src/views/Unauthorized';
import AuthLayout from './layouts/Auth';
import DashboardLayout from './layouts/Dashboard';
import ErrorLayout from './layouts/Error';
import ChatView from './views/Chat';
import OpenServiceView from './views/OpenService';
import ConfirmView from './views/Confirm';
import CloseConfirm from './views/CloseConfirm';
import CloseServiceView from './views/CloseService';
import OpenConfirmReport from './views/Report/OpenConfirmReport';
import CloseConfirmReport from './views/Report/CloseConfirmReport';
import EmployeeInformationReport from './views/Report/EmployeeInformationReport';
import EmployeeMultipleUsedIdReport from './views/Report/EmployeeMultipleUsedIdReport';
import JointService from './views/JointService';
import EmployeeIdentifyReport from './views/Report/EmployeeIdentifyReport';
import EmployeePhoneList from './views/Report/EmployeePhoneList';
import EmployeeTypeReport from './views/Report/EmployeeTypeReport';
import OpenReject from './views/OpenReject';
import CloseReject from './views/CloseReject';
import EmployeeView from './views/Employee';
import RoleView from './views/Role';
import EmployeeMainView from './views/EmployeeMain';
import SmsManagementDynamicView from './views/SmsManagementDynamic';
import SmsTrackingReportView from './views/SmsManagmentReports';
import SmsTemplateTrackingReportView from './views/SmsManagmentReports/SmsTemplateTrackingReport';
import RoleManagementView from './views/RoleManagement';
import HelpView from './views/Help';
import LaborManagement from './views/LaborManagement';
import HVACView from './views/HVAC';
import HVACReportView from './views/HVACReport';
import MaterialEquivalentView from './views/MaterialEquivalentReport';
import SestekAiView from './views/SestekAi';
import SestekAiReportView from './views/SestekAiReport';
import DealerShippingPricesView from './views/DealerShippingPrices';
import TeknisyenKocuGorusmeView from './views/TeknisyenKocuGorusme';
import BannerView from './views/Banner';
import YsHelp from './views/Help/yshelp';
import BeratManagement from './views/BeratManagement';
import ServiceManagement from './views/ServiceManagement';
import ServicePhotos from './views/ServicePhotos';
import ServiceInformations from './views/ServiceInformations';
import ServiceOperatorLog from './views/ServiceOperatorLog';
import ServiceVehicles from './views/ServiceVehicles';
import IndividualProductInquiryView from './views/IndividualProductInquiry';
import ReceiptDetailView from './views/IndividualProductInquiry/receiptDetail';
import ReceiptStatusHistoryView from './views/IndividualProductInquiry/ReceiptStatusHistory';
import ReceiptCustomerView from './views/IndividualProductInquiry/ReceiptCustomer';
import ReceiptCustomerDetailView from './views/IndividualProductInquiry/ReceiptCustomerDetail';
import IndividualInquiryReceiptsView from './views/IndividualProductInquiry/IndividualInquiryReceipts';
import WarrantyTypeDetailView from './views/SarisDynamicWarranty/WarrantyTypeDetail';
import ReportMonitoringView from './views/ReportMonitoring';
import SarisDynamicProductView from './views/SarisDynamicProduct';
import SarisDynamicWarrantyView from './views/SarisDynamicWarranty';
import SarisDynamicUnitView from './views/SarisDynamicUnit';
import SarisDynamicUnitDetailView from './views/SarisDynamicUnit/SarisDynamicUnitDetail';
import MultipleReceiptInquiryView from './views/MultipleReceiptInquiry';
import AssemblyBudgetDynamicTabView from './views/AssemblyBudget';
import RuleView from './views/Rule';
import UnregisteredReturnsView from './views/UnregisteredReturns';
import AsrReportsView from './views/ASRReports';
import ReportRequestScreen from './views/ReportRequestScreen/ReportRequestScreen';
import ReportRequestScreen_2 from './views/ReportRequestScreen/ReportRequestScreen';
import SarisDynamicServiceLaborMaterialView from './views/SarisDynamicServiceLaborMaterial';
import DynamicServiceDetailView from './views/SarisDynamicServiceLaborMaterial/DynamicServiceDetail';
import SarisDynamicOtherlView from './views/SarisDynamicOther';
import OtherDynamicDetaillView from './views/SarisDynamicOther/OtherDynamicDetail';
import SarisFcmCalculateView from './views/SarisFcmCalculate';
import ServiceVisit from './views/ServiceDealerVisit';
import CelebrationManagement from './views/CelebrationManagement';
import ReceiptQuery from './views/ReceiptQuery';
import LocationManagement from './views/LocationManagement';
import SearchWorkOrderView from './views/THWorkOrder/SearchWorkOrder';
import FileManagementView from './views/FileManagement';
import ServiceTrackingReport from './views/ServiceTracking';
import YSBeratManagement from './views/BeratManagement/YSBerat';
import ServiceVisitReport from './views/ServiceVisitReport';
import LaborFormView from './views/LaborForm';
import TeknisyenKocuChatView from './views/FileManagement/TeknisyenKocuChat';
import CreateBulletin from './views/Bulletin/CreateBulletin';
import BulletinList from './views/Bulletin/BulletinList';
import DraftList from './views/Bulletin/DraftList';
import PanelRepairDeliveriesView from './views/LogisticsTracking/PanelRepairDeliveries';
import PanelServicePickupsView from './views/LogisticsTracking/PanelServicePickups';

export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: Login
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/Unauthorized',
    component: ErrorLayout,
    routes: [
      {
        path: '/Unauthorized',
        exact: true,
        component: UnauthorizedView
      },
      {
        component: () => <Redirect to="/Unauthorized" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-404',
        exact: true,
        component: Error404
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/OpenService/:id',
        exact: true,
        component: Profil
      },
      {
        path: '/OpenService',
        exact: true,
        component: OpenServiceView
      },
      {
        path: '/Confirm',
        exact: true,
        component: ConfirmView
      },
      {
        path: '/CloseService',
        exact: true,
        component: CloseServiceView
      },
      {
        path: '/Help',
        exact: true,
        component: HelpView
      },
      {
        path: '/YsHelp',
        exact: true,
        component: YsHelp
      },
      {
        path: '/Chat',
        exact: true,
        component: ChatView
      },
      {
        path: '/profile/:id',
        exact: true,
        component: Profil
      },
      {
        path: '/profile/:id/:tab',
        exact: true,
        component: Profil
      },
      {
        path: '/SmsManagementDynamic',
        exact: true,
        component: SmsManagementDynamicView
      },
      {
        path: '/MaterialEquivalentReport',
        exact: true,
        component: MaterialEquivalentView
      },
      {
        path: '/SestekAi',
        exact: true,
        component: SestekAiView
      },
      {
        path: '/TeknisyenKocuGorusme',
        exact: true,
        component: TeknisyenKocuGorusmeView
      },
      {
        path: '/SestekAiReport',
        exact: true,
        component: SestekAiReportView
      },
      {
        path: '/Banner',
        exact: true,
        component: BannerView
      },
      {
        path: '/Rule',
        exact: true,
        component: RuleView
      },
      {
        path: '/UnregisteredReturns',
        exact: true,
        component: UnregisteredReturnsView
      },
      {
        path: '/DealerShippingPrices',
        exact: true,
        component: DealerShippingPricesView
      },
      {
        path: '/Employee',
        exact: true,
        component: EmployeeView
      },
      {
        path: '/HVAC',
        exact: true,
        component: HVACView
      },
      {
        path: '/HVACReport',
        exact: true,
        component: HVACReportView
      },
      {
        path: '/Role',
        exact: true,
        component: RoleView
      },
      {
        path: '/EmployeeInformation',
        exact: true,
        component: EmployeeInformationReport
      },
      {
        path: '/EmployeeMultipleUsedId',
        exact: true,
        component: EmployeeMultipleUsedIdReport
      },
      {
        path: '/EmployeeIdentifyReport',
        exact: true,
        component: EmployeeIdentifyReport
      },
      {
        path: '/EmployeePhoneList',
        exact: true,
        component: EmployeePhoneList
      },
      {
        path: '/EmployeeTypeReport',
        exact: true,
        component: EmployeeTypeReport
      },
      {
        path: '/EmployeeMain/:id',
        exact: true,
        component: EmployeeMainView
      },
      {
        path: '/close/confirm',
        exact: true,
        component: CloseConfirm
      },
      {
        path: '/report/openConfirm',
        exact: true,
        component: OpenConfirmReport
      },
      {
        path: '/report/closeConfirm',
        exact: true,
        component: CloseConfirmReport
      },
      {
        path: '/OpenReject',
        exact: true,
        component: OpenReject
      },
      {
        path: '/CloseReject',
        exact: true,
        component: CloseReject
      },
      {
        path: '/RoleManagement',
        exact: true,
        component: RoleManagementView
      },
      {
        path: '/ServiceManagement',
        exact: true,
        component: ServiceManagement
      },
      {
        path: '/JointService',
        exact: true,
        component: JointService
      },
      {
        path: '/BeratManagement',
        exact: true,
        component: BeratManagement
      },
      {
        path: '/ServicePhotos',
        exact: true,
        component: ServicePhotos
      },
      {
        path: '/ServiceInformations',
        exact: true,
        component: ServiceInformations
      },
      {
        path: '/ServiceOperatorLog',
        exact: true,
        component: ServiceOperatorLog
      }, {
        path: '/ServiceTracking',
        exact: true,
        component: ServiceTrackingReport
      },
      {
        path: '/YSBeratManagement',
        exact: true,
        component: YSBeratManagement
      },
      {
        path: '/ServiceVehicles',
        exact: true,
        component: ServiceVehicles
      },
      ,
      {
        path: '/ServiceDealerVisit',
        exact: true,
        component: ServiceVisit
      },
      {
        path: '/ServiceVisitReport',
        exact: true,
        component: ServiceVisitReport
      },
      {
        path: '/SarisQueries/IndividualProductInquiry',
        exact: true,
        component: IndividualProductInquiryView
      },
      {
        path: '/SarisQueries/ReceiptDetails/:ReceiptNumber',
        exact: true,
        component: ReceiptDetailView
      },
      {
        path: '/IndividualInquiryReceipts/:UYear/:UPeriod/:ModelCode/:SerialNo',
        exact: true,
        component: IndividualInquiryReceiptsView
      },
      {
        path: '/ReceiptStatusHistory/:ReceiptNumber',
        exact: true,
        component: ReceiptStatusHistoryView
      },
      {
        path: '/ReceiptCustomer/:PhoneNumber',
        exact: true,
        component: ReceiptCustomerView
      },
      {
        path: '/ReceiptCustomerDetail/:CustomerNo',
        exact: true,
        component: ReceiptCustomerDetailView
      },
      {
        path: '/SarisQueries/ReportMonitoring',
        exact: true,
        component: ReportMonitoringView
      },
      {
        path: '/SarisQueries/ReportRequestScreen',
        exact: true,
        component: ReportRequestScreen
      },
      {
        path: '/SarisQueries/ReportRequestScreen/:No',
        exact: true,
        component: ReportRequestScreen_2
      },
      {
        path: '/SarisDesc/SarisDynamicProduct',
        exact: true,
        component: SarisDynamicProductView
      },
      {
        path: '/SarisDesc/SarisDynamicWarranty',
        exact: true,
        component: SarisDynamicWarrantyView
      },
      {
        path: '/SarisDesc/SarisDynamicUnit',
        exact: true,
        component: SarisDynamicUnitView
      },
      {
        path: '/SarisDesc/SarisFcmCalculate',
        exact: true,
        component: SarisFcmCalculateView
      },
      {
        path: '/SarisDynamicUnitDetail/:UnitCode/:UserUnitCode/:UnitDesc',
        exact: true,
        component: SarisDynamicUnitDetailView
      },
      {
        path: '/SarisQueries/MultipleReceiptInquiry',
        exact: true,
        component: MultipleReceiptInquiryView
      },
      {
        path: '/WarrantyTypeDetail/:WarrantyType/:WarrantyDesc',
        exact: true,
        component: WarrantyTypeDetailView
      },
      {
        path: '/AsrReports/ArcelikServiceReports',
        exact: true,
        component: AsrReportsView
      },
      {
        path: '/AssemblyBudget/LaborPriceEstimation',
        exact: true,
        component: AssemblyBudgetDynamicTabView
      },
      {
        path: '/SarisDesc/SarisDynamicServiceLaborMaterial',
        exact: true,
        component: SarisDynamicServiceLaborMaterialView
      },
      {
        path: '/SarisDesc/SarisDynamicServiceLaborMaterialDetail/:UserCode/:ElType/:ElCode/:UserElCode/:Description',
        exact: true,
        component: DynamicServiceDetailView
      },
      {
        path: '/SarisDesc/SarisDynamicOther',
        exact: true,
        component: SarisDynamicOtherlView
      },
      {
        path: '/SarisDesc/OtherDynamicDetaill/:UserCode/:ElType/:ElCode/:UserElCode/:Description',
        exact: true,
        component: OtherDynamicDetaillView
      },
      {
        path: '/CelebrationManagement',
        exact: true,
        component: CelebrationManagement
      },
      {
        path: '/ReceiptQuery',
        exact: true,
        component: ReceiptQuery
      },
      {
        path: '/FileManagement',
        exact: true,
        component: FileManagementView
      },
      {
        path: '/LocationManagement',
        exact: true,
        component: LocationManagement
      },
      {
        path: '/SearchWorkOrder',
        exact: true,
        component: SearchWorkOrderView
      },
      {
        path: '/TeknisyenKocuSohbet',
        exact: true,
        component: TeknisyenKocuChatView
      },
      {
        path: '/LogisticsTracking/PanelRepairDeliveries',
        exact: true,
        component: PanelRepairDeliveriesView
      },
      {
        path: '/LogisticsTracking/PanelServicePickups',
        exact: true,
        component: PanelServicePickupsView
      },
      {
        path: '/LaborForm',
        exact: true,
        component: LaborFormView
      },
      {
        path: '/CreateBulletin',
        exact: true,
        component: CreateBulletin
      },
      {
        path: '/BulletinList',
        exact: true,
        component: BulletinList
      },
      {
        path: '/DraftList',
        exact: true,
        component: DraftList
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];
